import { Button, Space } from '@/components';
import { useCurrentFiscalYear } from '@/features/search/_hooks/get-current-fiscal-year';
import dayjs from 'dayjs';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  type KsAnalysisSearchFormType,
  KsAnalysisSearchSchema,
  initialValueOfKsAnalysisSearchForm,
} from '../_models/ks-analysis-search';

export const SearchButton: FC<{
  formId: string;
  onResetPayment: () => void;
}> = ({ formId, onResetPayment }) => {
  const { t } = useTranslation();
  const { reset } = useFormContext<KsAnalysisSearchFormType>();
  const currentFiscalYear = useCurrentFiscalYear();
  const initialValue = initialValueOfKsAnalysisSearchForm(
    currentFiscalYear.data ?? currentFiscalYear.basicFiscalYear,
  );
  return (
    <Space>
      <Button
        htmlType="button"
        type="default"
        onClick={async () => {
          const nullifiedValues = Object.keys(
            KsAnalysisSearchSchema.shape,
          ).reduce(
            (acc, key) => {
              acc[key] = null;
              return acc;
            },
            {} as Record<string, null>,
          );
          reset({
            ...nullifiedValues,
            ...initialValue,
            fiscalYear: dayjs().year(initialValue.fiscalYear),
          });
          onResetPayment();
        }}
      >
        {t('search-clear')}
      </Button>
      <Button form={formId} htmlType="submit" type="primary">
        {t('search-by')}
      </Button>
    </Space>
  );
};
